import { Box, Button, CircularProgress, FormHelperText } from '@mui/material';
import { CustomerLogo, StreamVX, TextFieldFormik, useModalContext } from '@vxui/components';
import { FormikProvider, useFormik } from 'formik';
import { FormEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Credentials } from '../models/auth';
import { useLoginMutation } from '../services';
import { validateLogin } from './LoginPage.helpers';

const init: Credentials = {
  login: '',
  password: '',
  force: true,
};

export const LoginPage = () => {
  const { t } = useTranslation();

  const [login, { isLoading, isError }] = useLoginMutation();
  const { hideAll } = useModalContext();

  const onSubmit = async (values: Credentials) => {
    try {
      const { data } = await login(values).unwrap();
      localStorage.setItem('token', data.token);
      location.reload();
    } catch (e) {
      console.error('Unable to read token from login response', e);
    }
  };

  const formik = useFormik<Credentials>({
    initialValues: init,
    onSubmit,
    validate: validateLogin,
  });

  useEffect(() => {
    hideAll();
  }, [hideAll]);

  const formSubmit = (e: FormEvent) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  return (
    <Box
      width="620px"
      margin="auto"
      padding={{ xs: '80px 40px', md: '120px 160px' }}
      bgcolor="common.white"
      borderRadius="8px"
      boxShadow="rgba(0, 0, 0, 0.1) 0px 5px 10px"
    >
      <Box display="flex" alignItems="center" justifyContent="center">
        {__APP_STYLE__ === 'customer' ? (
          <CustomerLogo height="40px" />
        ) : (
          <StreamVX className="Navigation-logo" height="30px" color="#000" />
        )}
      </Box>
      <FormikProvider value={formik}>
        <Box marginTop="24px">
          <form onSubmit={formSubmit}>
            <TextFieldFormik
              name="login"
              label={t('auth.forms.auth.fields.login.label')}
              autoComplete="username"
              autoFocus
            />
            <TextFieldFormik
              name="password"
              label={t('auth.forms.auth.fields.password.label')}
              autoComplete="current-password"
              type="password"
            />
            <FormHelperText error>{isError ? t('auth.forms.auth.invalid') : ' '}</FormHelperText>
            <Box marginTop="24px">
              <Button variant="contained" color="secondary" fullWidth type="submit" disabled={isLoading}>
                {isLoading ? <CircularProgress color="inherit" size="24px" /> : t('auth.forms.auth.logIn')}
              </Button>
            </Box>
          </form>
        </Box>
      </FormikProvider>
    </Box>
  );
};
